import { URLS } from "Interface/serviciosDisp.models"


export const assets : any = {
  3: "https://servicios.segurnet.com.do/public/images/claimsHome.svg"
}
// //DEV
// export const url: any = {
//   1: URLS.POLIZACOP,
//   2: URLS.FACTURACIONCOP,
//   3: URLS.REACLAMACIONESCOP
// }
// export const urlInv: any = {
//   1: URLS.POLIZA,
//   2: URLS.FACTURACIONCOP,
//   3: URLS.REACLAMACIONESCOP
// }

//PROD
export const url: any = {
  5: URLS.POLIZACOP,
  6: URLS.FACTURACIONCOP,
  7: URLS.REACLAMACIONESCOP
}
export const urlInv: any = {
  5: URLS.POLIZA,
  6: URLS.FACTURACIONCOP,
  7: URLS.REACLAMACIONESCOP
}
